module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("New Agent Protocol")]), _vm._v(" "), _c('h3', [_vm._v("Please insert agent details")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('agent-new', {
    on: {
      "toggleIsDisabled": _vm.toggleIsDisabled,
      "readyToSave": _vm.readyToSave
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-end",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-19c6dc7c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c6dc7c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/AgentAdd.vue
// module id = 857
// module chunks = 0